import { z } from 'zod';

/** Rechte je Nutzer – identisch zur bisherigen PHP-Middleware (all_perm_keys). */
/** ankauf_lesen: Ankauf nur ansehen (Read-only), ankauf: bearbeiten – neu gegenüber der PHP-Middleware */
/** erp: ERP-Connector einrichten und Fehler bearbeiten (neu) */
export const RECHTE = ['view_dashboard', 'marketplace', 'channels', 'payouts', 'admin', 'users', 'ankauf', 'ankauf_lesen', 'erp'] as const;
export type Recht = (typeof RECHTE)[number];
export const RechteSchema = z.record(z.enum(RECHTE), z.boolean());
export type Rechte = z.infer<typeof RechteSchema>;

/** dxl_admin = Plattform (DXL), admin/mitarbeiter = Nutzer eines Marktplatzes */
export const ROLLEN = ['dxl_admin', 'admin', 'mitarbeiter'] as const;
export type Rolle = (typeof ROLLEN)[number];

/** erp: ERP-Connector (Business Central ↔ Shopify, docs/erp-connector.md) */
export const MODULE = ['marktplatz', 'ankauf', 'werbung', 'erp'] as const;
export type Modul = (typeof MODULE)[number];

export function standardRechte(rolle: Rolle): Rechte {
  const alle = Object.fromEntries(RECHTE.map((r) => [r, true])) as Rechte;
  if (rolle === 'mitarbeiter') {
    alle.admin = false;
    alle.users = false;
    alle.payouts = false;
    alle.erp = false;
  }
  return alle;
}

/** Zwei-Faktor ist für Administratoren Pflicht – wie bisher. */
export function zweiFaktorPflicht(rolle: Rolle): boolean {
  return rolle === 'dxl_admin' || rolle === 'admin';
}
